import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import ProductsPage from './pages/ProductsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfSale from './pages/TermsOfSale';
import TermsOfService from './pages/TermsOfService';
import ScrollToTop from './components/ScrollToTop';
import "./style/AppColors.css"
import { CartProvider } from './contexts/CartContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import CheckoutPage from './pages/CheckoutPage';
import OrderCompletePage from './pages/OrderCompletePage';
import OrderFailedPage from './pages/OrderFailedPage';
import LoginPage from './pages/Account/LoginPage';
import RegisterPage from './pages/Account/RegisterPage';
import UpdatePage from './pages/Account/UpdatePage';
import OrderPage from './pages/OrderPage';
import CreationSuccessPage from './pages/Account/CreationSuccessPage';
import ForgotPasswordPage from './pages/Account/ForgotPasswordPage';
import ResetPasswordPage from './pages/Account/ResetPasswordPage';
import ConfirmationPage from './pages/Account/ConfirmationPage';
import { CartMenuProvider } from './contexts/CartMenuContext';
import { HamburgerMenuProvider } from './contexts/HamburgerMenuContext';
import ProtectedRoute from './controllers/AccountConnectionLayer';
import AgeConfirmation from './components/AppConfirmation';
import MediaContact from './pages/MediaContactPage';
import AboutUs from './pages/AboutUsPage';
import ChooseAwootoysSilicone from './pages/ChooseAwootoysSiliconePage';
import SoftnessGuide from './pages/SoftnessGuidePage';
import CareGuide from './pages/CareGuidePage';
import ContactUs from './pages/ContactUsPage';
import Retailers from './pages/RetailersPage';

import LoginPageStripped from './pages/Account/LoginPageStripped';
import { Analytics } from "@vercel/analytics/react"
import NewsletterPopUp from './components/NewsletterPopUp';
import ParallaxBackground from './components/ParallaxBackground';

const App = () => {

  return (
    <>
      <Analytics />
      <CurrencyProvider>
        <CartMenuProvider>
          <CartProvider>
            <HamburgerMenuProvider>
              <Router>
                <NewsletterPopUp/>
                <AgeConfirmation />
                <ScrollToTop />
                <Header />
                <div className="page-container">
                  <main class="background-color">
                    <ParallaxBackground />
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/product/:name" element={<ProductPage />} />
                      <Route path="/products" element={<ProductsPage />} />

                      <Route path="/terms-of-service" element={<TermsOfService />} />
                      <Route path="/terms-of-sale" element={<TermsOfSale />} />
                      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                      <Route path="/media" element={<MediaContact />} />
                      <Route path="/about" element={<AboutUs />} />
                      <Route path="/why-choose-us" element={<ChooseAwootoysSilicone />} />
                      <Route path="/softness-guide" element={<SoftnessGuide />} />
                      <Route path="/retailers" element={<Retailers />} />
                      <Route path="/care-guide" element={<CareGuide />} />
                      <Route path="/contact" element={<ContactUs />} />

                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/order-complete" element={< OrderCompletePage/>}/>
                      <Route path="/order-failed" element={< OrderFailedPage/>}/>
                      <Route path="/account/login" element={< LoginPage/>}/>
                      <Route path="/account/register" element={< RegisterPage/>}/>
                      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                      <Route path="/confirmation" element={<ConfirmationPage/>}/>
                      <Route path="/account/success" element={<CreationSuccessPage />} />
                      {/* <Route path="/login-pre-release" element={<LoginPageStripped/>}/> */}


                      <Route element={<ProtectedRoute />}>
                        {/* <Route path="/" element={<HomePage />} />
                        <Route path="/product/:name" element={<ProductPage />} />
                        <Route path="/products" element={<ProductsPage />} />

                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/terms-of-sale" element={<TermsOfSale />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/media" element={<MediaContact />} />
                        <Route path="/about" element={<AboutUs />} />
                        <Route path="/why-choose-us" element={<ChooseAwootoysSilicone />} />
                        <Route path="/softness-guide" element={<SoftnessGuide />} />
                        <Route path="/care-guide" element={<CareGuide />} />
                        <Route path="/contact" element={<ContactUs />} />

                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/order-complete" element={< OrderCompletePage/>}/>
                        <Route path="/order-failed" element={< OrderFailedPage/>}/>
                        <Route path="/account/login" element={< LoginPage/>}/>
                        <Route path="/account/register" element={< RegisterPage/>}/>
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                        <Route path="/reset-password" element={<ResetPasswordPage />} />
                        <Route path="/confirmation" element={<ConfirmationPage/>}/> */}
                        <Route path="/account/update" element={<UpdatePage />} />
                        <Route path="/order/:orderId" element={<OrderPage />} />
                      </Route>
                    </Routes>
                    <Toaster />
                  </main>
                </div>
                <Footer />
              </Router>
            </HamburgerMenuProvider>
          </CartProvider>
        </CartMenuProvider>
      </CurrencyProvider>
    </>
  );
};

export default App;